module.exports = __webpack_public_path__ + "img/5_96.fa4ccaeb.png";